import { Model } from './model';

export class Survey extends Model {
  _id: any;
  components: any;
  show_completion_score: boolean;
  responses: any;
}



// WEBPACK FOOTER //
// ./src/app/api/resources/survey.ts